<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="700"
  >
    <validation-observer
      ref="assignFormValidator"
    >
      <v-card>
        <v-card-title>
          <v-row
            v-if="driver"
          >
            <v-col cols="12" md="4">
              <v-avatar
                color="primary"
                size="40"
              >
                <v-img
                  v-if="driver.image_url"
                  :src="driver.image_url"
                  alt="avatar"
                />
                <span v-else class="primary white--text" style="font-size: 80%">
                  {{ driver.name.slice(0, 2) }}
                </span>
              </v-avatar>
              &nbsp;<small>{{ driver.name }}</small>
            </v-col>
            <v-col cols="12" md="8" class="text-left">
              <div class="text--accent-4">
                {{ targetDate | date_format }}の受注を登録する
              </div>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-row dense>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="searchForms.searchKeyword"
                clearable
                dense
                hide-details="auto"
                label="運搬先"
                outlined
                placeholder="運搬先を検索"
                persistent-placeholder
                rounded
                style="font-size: 80%"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="searchForms.orderNumber"
                background-color="white"
                dense
                hide-details="auto"
                label="受注番号"
                outlined
                rounded
                persistent-placeholder
                clearable
                style="font-size: 80%"
              />
            </v-col>
            <v-col cols="12" md="4">
              <div>
                <v-checkbox
                  v-model="searchForms.searchWithAssign"
                  dense
                  hide-details
                  label="配車済も表示"
                >
                </v-checkbox>
              </div>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="searchForms.requestNumber"
                clearable
                dense
                hide-details="auto"
                label="依頼番号"
                outlined
                persistent-placeholder
                rounded
                style="font-size: 80%"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="searchForms.dealNumber"
                background-color="white"
                dense
                hide-details="auto"
                label="取引番号"
                outlined
                rounded
                persistent-placeholder
                clearable
                style="font-size: 80%"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="searchForms.searchOrderKeyword"
                dense
                hide-details="auto"
                label="検索キーワード"
                outlined
                rounded
                persistent-placeholder
                clearable
                style="font-size: 80%"
              />
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-text-field
                v-model="searchForms.supplierName"
                clearable
                dense
                filled
                hide-details="auto"
                label="取引先"
                outlined
                persistent-hint
                persistent-placeholder
                rounded
                readonly
                style="font-size: 80%"
                @click:clear="supplierClearButtonClickEvent"
              >
                <template v-slot:append-outer>
                  <choose-supplier-button
                    :small-button="true"
                    @choseSupplierCallback="choseSupplierCallback"
                  />
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
            <v-btn
              :disabled="disableActions"
              rounded
              color="info"
              @click="searchButtonClickEvent"
            >
              検索
            </v-btn>
        </v-card-actions>
        <v-divider />
        <v-card-text
          style="height: 45vh;
          overflow-y: auto"
        >
          <v-row>
            <v-col>
              <v-card flat>
                <v-row dense>
                  <v-col
                    v-for="order in orders"
                    :key="order.id"
                    cols="12" md="4"
                    class="order-list"
                  >
                    <div style="width: 100%; position: relative">
                          <span
                            v-if="order.urgent"
                            class="white--text chip urgent"
                          >
                            <strong>急</strong>
                          </span>
                      <span
                        v-else-if="order.unregistered"
                        class="white--text chip unregistered"
                      >
                            <strong>未</strong>
                          </span>
                      <v-card class="rounded-card">
                        <v-card-text>
                          <v-row>
                            <v-col cols="1" md="1" class="text-left pl-1 pr-1">
                                  <span
                                    v-if="order.checked"
                                    class="white--text"
                                    style="position: absolute; top: 10%;text-align:center;background-color: #0074BA;width: 25px;height:25px;border-radius: 12px;"
                                  >
                                    {{ order.sort_priority }}
                                  </span>
                              <!-- 配車済はチェックボックスを出さない -->
                              <v-checkbox
                                v-if="!order.assigned"
                                v-model="order.checked"
                                @click="checkboxClickEvent(order)"
                              />
                            </v-col>
                            <v-col cols="11" md="10">
                              <v-row>
                                <v-col cols="12" class="pt-1 pb-1">
                                  <div class="pl-2">
                                    <strong
                                      v-if="order.preferred_start_time || order.preferred_end_time"
                                      class="red--text"
                                    >
                                      {{ order.preferred_start_time }}-{{ order.preferred_end_time }}
                                    </strong>
                                    <strong v-else>
                                      &nbsp;
                                    </strong>
                                  </div>
                                  <h5
                                    class="pl-1"
                                    :title="`受注番号: ${ order.order_no }\n${ order.supplier_name || '' }\n${ order.supplier_location_name || '' }: ${ order.supplier_location_address }`"
                                  >
                                    {{ order.supplier_name }}
                                  </h5>
                                  <div>
                                    <h6
                                      v-bind="attrs"
                                      v-on="on"
                                      class="pl-1"
                                    >
                                      {{ order.supplier_location_name }}
                                    </h6>
                                  </div>
                                  <div class="pl-2">
                                    <v-chip
                                      v-if="order.item_name"
                                      :title="`${ order.all_item_name || '' }`"
                                      style="background-color: #F0E6D0;"
                                      label
                                      x-small
                                    >
                                      {{ order.item_name | truncate(10) }}
                                    </v-chip>
                                    <small><span v-if="order.total_items_count > 1">&emsp;全&nbsp;{{ order.total_items_count }}件</span></small>
                                    <span v-if="!order.item_name">&emsp;</span>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn
            @click="clearButtonClickEvent"
          >
            クリア
          </v-btn>
          <v-spacer/>
          <v-btn
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
          &nbsp;
          <v-btn
            :disabled="checkedResults.length <= 0"
            color="primary"
            @click="registerButtonClickEvent"
          >
            ドライバーに割当&nbsp;<v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
  </v-dialog>
</template>

<script>

import _ from 'lodash'
import ChooseSupplierButton from '@/driver/components/ChooseSupplierButton.vue'
import { mapActions } from 'vuex'

export default {
  name: 'AllocationUnregisteredOrderDialog',
  components: {
    ChooseSupplierButton
  },
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    targetDate: {
      type: String,
      default: () => null,
    },
    targetDriverId: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      searchForms: {
        searchKeyword: '',
        orderNumber: '',
        requestNumber: '',
        dealNumber: '',
        searchWithAssign: false,
        searchOrderKeyword: '',
        supplierId: null,
        supplierType: null,
        supplierName: null,
      },
      driver: null,
      orders: [],
      checkedResults: [],
      disableActions: false,
    }
  },
  computed: {
  },
  watch: {
    enableDialog (newValue) {
      this.checkedResults = []
      this.orders = []
      this.driver = null
      Object.assign(this.$data.searchForms, this.$options.data().searchForms);
      if (newValue) {
        this.clearButtonClickEvent()
        this.setVariable()
      }
    },
  },
  created() {
  },
  methods: {
    ...mapActions('DriverAllocationUnregisteredOrder', {
      fetchOrders: 'index',
    }),
    ...mapActions('DriverAllocationDriverAssign', {
      assignToDriver: 'update',
    }),
    ...mapActions('DriverMasterUser', {
      fetchDriver: 'show'
    }),
    /**
     * チェックボックス クリックイベント
     * @param item
     */
    checkboxClickEvent (item) {
      if (item.checked) {
        this.checkedResults.push(item)
      } else {
        this.checkedResults = this.checkedResults.filter((_item) => {
          return _item.id !== item.id
        })
      }
      let index = 0
      for (let result of this.checkedResults) {
        index = index + 1
        result.sort_priority = index
      }
    },
    /**
     * クリアボタン クリックイベント
     * 選択状態をすべてクリアする.
     */
    clearButtonClickEvent () {
      for (const order of this.orders) {
        order.sort_priority = 0
        order.checked = false
      }
      this.checkedResults = []
    },
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeEvent')
    },
    /**
     * 選択したタスクを登録するボタン クリックイベント
     * 選択されたタスクを格納し、親画面に戻します.
     *
     */
    registerButtonClickEvent () {
      let works = _.cloneDeep(this.orders)
      // チェックされた受注を抽出
      works = works.filter(v => v.checked)
      // 設定された並び順で並び替え
      works.sort((a, b) => {
        return a.sort_priority < b.sort_priority ? -1 : 1;
      });

      //　選択された受注のIDを抜き出す
      let ids = []
      works.forEach( v => ids.push(v.order_id))
      let params = { target_date: this.targetDate, order_ids: ids }
      this.assignToDriver({ driver_id: this.targetDriverId, params: params }).then(() => {
        this.$emit('registerEvent')
      })
    },
    supplierClearButtonClickEvent () {
      this.searchForms.supplierId = null
      this.searchForms.supplierType = null
      this.searchForms.supplierName = null
    },
    /**
     * 取引先選択ボタンからのダイアログのコールバック
     * @param item
     */
    choseSupplierCallback (item) {
      this.searchForms.supplierId = item.id
      this.searchForms.supplierType = item.type
      this.searchForms.supplierName = item.name
    },
    /**
     * 検索ボタン クリックイベント
     */
    searchButtonClickEvent () {
      this.clearButtonClickEvent()
      this.searchAssigns()
    },
    setVariable () {
      this.fetchDriver({id: this.targetDriverId}).then((content) => {
        this.driver = content
        this.searchAssigns()
      })
    },
    /**
     * 検索処理の実行
     */
    searchAssigns () {
      let params = {
        target_date: this.targetDate,
        keyword: this.searchForms.searchKeyword,
        order_number: this.searchForms.orderNumber,
        request_number: this.searchForms.requestNumber,
        deal_number: this.searchForms.dealNumber,
        order_keyword: this.searchForms.searchOrderKeyword,
        supplier_type: this.searchForms.supplierType,
        supplier_id: this.searchForms.supplierId,
        with_assigned: this.searchForms.searchWithAssign,
      }
      this.disableActions = true
      /**
       * @typedef content { Object }
       * @property assigns { Array }
       */
      this.fetchOrders(params).then((content) => {
        this.orders = content.orders
        this.disableActions = false;
      })
    }
  }
}
</script>

<style scoped lang="scss">
.chip {
  width: 25px;
  height: 25px;
  position: absolute;
  z-index: 2;
  right: 0;
  top: -4px;
  text-align: center;
  border-radius: 12px;
  &.urgent {
    background-color: red;
  }
  &.unregistered {
    background-color: #1FAAD1;
  }
}

.order-list {
  & h5 {
    white-space:nowrap;
    width: 100%;
    overflow:hidden;
    text-overflow:ellipsis;
  }

  & h6 {
    white-space:nowrap;
    width: 100%;
    overflow:hidden;
    text-overflow:ellipsis;
  }
}

</style>
